import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { LoginPage } from '../pages/login/login';
import {AccountPage} from '../pages/account/account';
import {CategoryPage} from '../pages/category/category';
import {PeriodicTransactionPage} from '../pages/periodic-transaction/periodic-transaction';
import {ReportPage} from '../pages/report/report';

import { AuthenticationServiceProvider } from '../providers/authentication-service/authentication-service';


@Component({
    templateUrl: 'app.html'
})
export class MyApp {
    rootPage: any = AccountPage;
    account:any = AccountPage;
    category:any = CategoryPage;
    periodic_transactions:any = PeriodicTransactionPage;
    report:any = ReportPage;

    constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, public authService: AuthenticationServiceProvider) {
        platform.ready().then(() => {
            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need
            statusBar.styleDefault();
            splashScreen.hide();
        });

        if (authService.IsAuthenticated()) {
            this.rootPage = AccountPage
        }
        else {
            this.rootPage = LoginPage
        }
    }

    doLogout(){
        this.authService.ClearCredentials()
        this.rootPage = LoginPage
    }

    openPage(p) {
        this.rootPage = p;
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts